import cn from 'classnames';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from '@widgets/events';
import { getInitial } from '@shared/helpers';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { EventDescription, EventEnd, EventModeration } from 'library/components/events';
import { checkEventEnd } from 'library/helpers/events/dateSets';
import { useModeration } from 'library/hooks/events';
import type { Event } from 'library/models/events';
import * as st from './EventCard.module.scss';

interface Props {
  event: Event;
  onDelete: (id: number) => void;
}

const EventCard: FC<Props> = ({ event, onDelete }) => {
  const { permissions, code } = useModuleByCodeParam();
  const moderation = useModeration({ event });
  const eventUrl = `/events/${code}/${event.id}`;
  const authorName = getInitial(
    event.author.first_name,
    event.author.last_name,
    event.author.middle_name
  );

  return (
    <div className={st.card}>
      <Link to={eventUrl} className={cn(st.image, st[moderation.getModerationClass()])}>
        <div style={{ minWidth: '160px' }}>
          <img src={event.event_image} alt="" />
        </div>
      </Link>

      <div className={st.data}>
        <section className={st.data__top}>
          <Link to={eventUrl} className={st.data__title}>
            <h3>{event.title}</h3>
            <p>{authorName}</p>
          </Link>
          <div className={st.data__menu}>{<Menu event={event} onDelete={onDelete} />}</div>
        </section>
        <section className={st.data__bottom}>
          <Link to={eventUrl} className={st.data__details}>
            <div className={st.data__description}>
              <EventDescription event={event} size="small" type="date" />
              <EventDescription event={event} size="small" type="time" />
              <EventDescription event={event} size="small" type="cost" />
              <EventDescription event={event} size="small" type="typeMeeting" />
            </div>
          </Link>

          {moderation.getModerationClass() !== '' && (
            <>
              <div className={st.data__moderation}>
                {checkEventEnd(event.time_to) ? (
                  <EventEnd size="small" className={st.end} />
                ) : (
                  <>
                    {permissions.can_sell && moderation.showModeration && (
                      <div className={st.moderation}>
                        <EventModeration
                          status={event.moderation_status.abbr_status}
                          published={event.published}
                          publicate={moderation.publicateEvent}
                          showModerationText={moderation.showModerationText}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </section>
      </div>
    </div>
  );
};

export default EventCard;
